import * as React from "react";
import type { SVGProps } from "react";
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.998 3.5a1 1 0 0 1 .909.582l2.018 4.39 4.798.562a1 1 0 0 1 .562 1.729l-3.552 3.275.948 4.738a1 1 0 0 1-1.47 1.068l-4.213-2.365-4.212 2.365a1 1 0 0 1-.98-1.744l4.703-2.64.49-.275.489.275 2.805 1.575-.63-3.155-.11-.55.412-.381 2.365-2.181-3.196-.375-.557-.066-.235-.51-1.344-2.923-1.343 2.923-.235.51-.558.066-3.195.374 2.365 2.182a1 1 0 0 1-1.356 1.47l-3.964-3.656a1 1 0 0 1 .561-1.729l4.799-.562 2.018-4.39a1 1 0 0 1 .908-.582"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgStar;
